<template>
  <Drawer
    width="800"
    :title="`${openedSalesContract ? '编辑' : '新增'}销售合同`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
        :loading="customerLoading"
      >
        <FormItem label="客户" prop="customer" style="width: 250px">
          <Select
            v-model="formItem.customer"
            filterable
            :disabled="openedSalesContract ? true : false"
            remote
            style="width: 250px"
            :remote-method="remoteMethod"
            placeholder="请选择客户"
          >
            <Option
              v-for="option in customersSimple"
              :value="option._id"
              :key="option._id"
              style="width: 366px"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="合同编号" prop="number">
          <Input
            type="text"
            style="width: 250px"
            v-model="formItem.abbr"
            placeholder="合同编号"
          />
        </FormItem>
        <FormItem label="我方公司" prop="company">
          <Input
            type="text"
            style="width: 250px"
            v-model="formItem.abbr"
            placeholder="我方公司"
          />
        </FormItem>
        <FormItem label="开始时间" prop="startDate">
          <DatePicker
            v-model="formItem.startDate"
            type="date"
            placeholder="选择开始时间"
            style="width: 200px"
          ></DatePicker>
        </FormItem>
        <FormItem label="到期时间" prop="endDate">
          <DatePicker
            v-model="formItem.endDate"
            type="date"
            placeholder="选择到期时间"
            style="width: 200px"
          ></DatePicker>
        </FormItem>
        <FormItem label="账期月数" prop="estAging">
          <InputNumber :min="0" v-model="formItem.estAging"></InputNumber>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateSalesContractDrawer",
  data() {
    return {
      drawerOpened: false,
      openedSalesContract: null,
      customerLoading: false,
      formItem: {
        estAging: 0,
      },
      ruleValidate: {},
    };
  },
  computed: {
    ...mapState({
      customersSimple: (state) => state.customer.customersSimple,
    }),
  },
  methods: {
    ...mapActions({
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
    }),
    async openDrawer(salesContract) {
      this.drawerOpened = true;
    },
    handleSubmit(s) {
    },
    async remoteMethod(query) {
      if (query !== "") {
        this.customerLoading = true;
        await this.getCustomerSimpleList({ name: query });
        this.customerLoading = false;
      }
    },
  },
};
</script>
<style lang="stylus" scoped></style>